import { Constants } from '@src/app/commons/Constants';
import { DEBUG } from '@src/DEBUG';
import { XsBaseClass } from './base.class';
DEBUG.open ( '/xs/controllers/await' );

// import * as _ from 'lodash'
// import { Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';

/*
  Eventify a service / helper / controller / whatever
*/

export class XsAwait extends XsBaseClass {

  debugId:string = 'AWAIT_CLASS';

  // factory function
  static waitFor ( these:any[], delayTime:number = 200 ) {
    return new Promise ( resolve => {
      const inst = new XsAwait(these,resolve, { delayTime: delayTime });
    });
  }

  static until ( these:any, context:any = null, delayTime:number = 200 ) {
    return new Promise ( resolve => {
      const inst = new XsAwait( Array.isArray(these) ? these : [these], resolve, { context:context, delayTime: delayTime });
    });
  }

  _config_default = {
    delayTime: 200, 
    maxTime: 10000
  }

  context:any = null;

  uuid:string = this.uuidv4();

  // our items to check
  items:any[] = null;

  // the main Promise
  // p:any = null;
  resolve:any = null;

  // isResolved?
  isResolved:boolean = false;

  // sum up the total time we've waited
  totalTime:number = 0;

  constructor ( items:any, resolve:any, config:any = {} ) {

    super( config );

    if ( this._config.context )

    DEBUG.log ( '/xs/controllers/await' );

    this.parentClass = this.constructor.name;

    this.__log ( 'CONSTRUCTOR', items );

    // console.log('##await ['+this.uuid+'] start', items, this._config );

    // our items to check
    this.items = items;

    // transfer the Promise and resolve
    this.resolve = resolve;

    // start checking
    this.check();

  }

  check() {
    const me = this;
    if ( this.checkItems() ) {
      this.__log ( 'check() RESOLVE' );
      // console.log('##await ['+this.uuid+'] took '+this.totalTime+'ms ', this );
      this.resolve(this.items);
    } else {
      this.__log ( 'check() again ...' );
      if ( this.totalTime > this._config.maxTime ) {
        console.log('%c ##await ['+this.uuid+'] timeout after '+this.totalTime+'ms ', Constants._red, this );
      } else {
        setTimeout ( () => { me.check(); me.totalTime = me.totalTime + me._config.delayTime }, this._config.delayTime );
      }
    }
  }

  checkItems () {
    let ret:boolean = false;
    try {
      if ( this.items && this.items.length ) {
        const max:number = this.items.length;
        let cur:number = 0;
        let previous:boolean = true;
        this.items.forEach ( item => {
          let itemCheck:boolean = false;
          let itemChildrenCheck:boolean = false;
          let itemChildrenTest:boolean = false;

          let type = typeof item;
          // console.log ( 'await TRY', type );

          if ( type == 'string' ) {
            // incoming path in the form of a string
            if ( this.reach( item, this._config.context ) ) {
              cur++;
              previous = true;
            }
          } else {
            if ( item.hasOwnProperty('object') ) {
              if ( item.object ) {
                itemCheck = true;
              }
            }
          }
          
          if ( itemCheck && previous ) {
            previous = false;
            if ( item.hasOwnProperty('children') ) {
              itemChildrenTest = true;
              let itemMax = item.children.length;
              let itemCur:number = 0;
              if ( item.children && item.children.length ) {
                item.children.forEach( child => {
                  if ( item.object && item.object[child] ) {
                    itemCur++;
                  }
                });
              }
              if ( itemCur == itemMax ) {
                itemChildrenCheck = true;
              }
            } else if ( item.hasOwnProperty('child') ) {
              itemChildrenTest = true;
              if ( item.object && item.object[item.child] ) {
                itemChildrenCheck = true;
              }
            }
          }
          if ( itemChildrenTest ) {
            if ( itemCheck && itemChildrenCheck ) {
              cur++;
              previous = true;
            }
          } else {
            if ( itemCheck ) {
              cur++;
              previous = true;
            }
          }
        });
        if ( cur == max ) {
          ret = true;
        }
        this.__log ( 'checkItems() done', [ ret, this.items ] );
      }  
    } catch (error) {
      // console.log('## await error', error, this );
    }
    return ret;
  }

    // reach sets properties of the current object (this) according to a path (delimited by '.');
  //  - reach ( 'myProp', value ) = this.myProp = value
  //  - reach ( 'someObj.subObj.myValue', value ) = this.someObj.subObj.myValue = value
  
  reach ( path:string = '', sofar:any = null, depth:number = 0 ) {

    // if ( !depth ) { console.log ( 'await reach('+path+') START', sofar); }

    if ( path.indexOf('.') !== -1 ) {
      let token = path.split('.')[0];
      let after = path.substring(path.indexOf('.') + 1);
      // any objects to traverse into?
      if ( sofar[token] ) {
        return this.reach ( after, sofar[token], depth + 1 );
      } else {
        // console.log ( 'await reach() FAILED at depth ['+depth+']', path );
        return null;
      }
      
    } else {
      if ( sofar[path] ) {
        // console.log ( 'await reach() DELIVERED at depth ['+depth+']', sofar[path] );
        return sofar[path];
      } else {
        // console.log ( 'await reach() FAILED at depth ['+depth+']', path );
        return null;
      }
      return sofar[path];
    } 
  }

  uuidv4() {
    return 'xxxx-0yx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

}
